import React from "react";

const GuestUsersTermsKn = () => {
  return (
    <div className="body_style">
      <div className="letters-color-section">
        <h3 className="letters-color-section-main-heading">
          ಅತಿಥಿ ಬಳಕೆದಾರರ ನಿಯಮಗಳು
        </h3>
        <div className="letters-color-section-sub-heading-section">
          <h5 className="letters-color-section-sub-heading">
            ಅತಿಥಿ ಬಳಕೆದಾರ ವಹಿವಾಟುಗಳಿಗೆ ನಿಯಮಗಳು ಮತ್ತು ಷರತ್ತುಗಳು:
          </h5>
        </div>
        <div className="letters-color-section-table-section">
          <div className="heading-main">
            ಅತಿಥಿ ಬಳಕೆದಾರ ವಹಿವಾಟುಗಳಿಗೆ ನಿಯಮಗಳು ಮತ್ತು ಷರತ್ತುಗಳು:
            <div className="heading">
              <ol>
                <li>
                  KSRTC ಇಂಟರ್ನೆಟ್ ಮೂಲಕ KSRTC ಯ ಪ್ರಯಾಣಿಕರ ಮೀಸಲಾತಿ ವ್ಯವಸ್ಥೆಯೊಂದಿಗೆ
                  ವಹಿವಾಟು ಮಾಡುವ ಸೌಲಭ್ಯವನ್ನು ಮಾತ್ರ ಒದಗಿಸುತ್ತದೆ. ಲಾಗಿನ್
                  ಮಾಹಿತಿಯಿಲ್ಲದೆ ಅತಿಥಿ ಬುಕಿಂಗ್ ಮೂಲಕ ಮಾನ್ಯ ಲಾಗಿನ್
                  ಪ್ರೊಸೆಸರ್‌ನೊಂದಿಗೆ ಕೆಎಸ್‌ಆರ್‌ಟಿಸಿ ಬಸ್ ಟಿಕೆಟ್‌ಗಳಿಗಾಗಿ ಬುಕ್ ಮಾಡಲು
                  ಕೆಎಸ್‌ಆರ್‌ಟಿಸಿ ಬಳಕೆದಾರರನ್ನು ಅನುಮತಿಸುತ್ತದೆ. KSRTC ಯ
                  ಕಾಯ್ದಿರಿಸುವಿಕೆ ಮತ್ತು ಬುಕಿಂಗ್ ನಿಯಮಗಳು ಇಂಟರ್ನೆಟ್ ಆಧಾರಿತ
                  ಬುಕಿಂಗ್‌ಗೆ ವಿಧಿಸಲಾದ ವಿಶೇಷ ಷರತ್ತುಗಳೊಂದಿಗೆ ಎಲ್ಲಾ ವಹಿವಾಟುಗಳಿಗೆ
                  ಅನ್ವಯಿಸುತ್ತವೆ. ಇಂಟರ್ನೆಟ್ ಬುಕಿಂಗ್‌ಗೆ ಅನ್ವಯವಾಗುವ ವಿಶೇಷ ಷರತ್ತುಗಳು
                  ಮತ್ತು ಸೇವಾ ನಿಯಮಗಳನ್ನು ಈ ಡಾಕ್ಯುಮೆಂಟ್‌ನಲ್ಲಿ ವಿವರವಾಗಿ ತಿಳಿಸಲಾಗಿದೆ
                  .
                </li>
                <li>
                  KSRTC ಕೇವಲ ಬುಕಿಂಗ್ ಮತ್ತು ಪ್ರಯಾಣದ ಇತಿಹಾಸದ ಆಧಾರದ ಮೇಲೆ ಮಾನ್ಯವಾದ
                  ಲಾಗಿನ್ ಮಾಹಿತಿಯೊಂದಿಗೆ ನೋಂದಾಯಿತ ಬಳಕೆದಾರರಿಗೆ ಮಾತ್ರ ಲಾಯಲ್ಟಿ
                  ಪ್ರಯೋಜನಗಳನ್ನು ನೀಡುತ್ತದೆ.
                </li>
                <li>
                  KSRTC ವೆಬ್‌ಸೈಟ್ ಮೂಲಕ ನೀಡಲಾಗುವ KSRTC ಯ ಆನ್‌ಲೈನ್ ಟಿಕೆಟ್ ಬುಕಿಂಗ್
                  ಸೇವೆಯನ್ನು ಬಳಸಲು ಬಯಸುವ ಬಳಕೆದಾರರಿಗೆ ಈ ಕೆಳಗಿನ ನಿಯಮಗಳು ಮತ್ತು
                  ಷರತ್ತುಗಳು ಅನ್ವಯಿಸುತ್ತವೆ. ಸ್ವೀಕಾರವನ್ನು ಒದಗಿಸುವ ಮೊದಲು ದಯವಿಟ್ಟು
                  ನಿಯಮಗಳು ಮತ್ತು ಷರತ್ತುಗಳನ್ನು ಓದಿ ಮತ್ತು ಅರ್ಥಮಾಡಿಕೊಳ್ಳಿ. KSRTC
                  ವೆಬ್‌ಸೈಟ್‌ನಲ್ಲಿ ವಹಿವಾಟು ನಡೆಸಲು ನಿಯಮಗಳು ಮತ್ತು ಷರತ್ತುಗಳನ್ನು
                  ಒಪ್ಪಿಕೊಳ್ಳುವುದು ಅವಶ್ಯಕ. ಬಳಕೆದಾರರು ಮಾನ್ಯ ಲಾಗಿನ್ ಮಾಹಿತಿಯೊಂದಿಗೆ
                  ಅಥವಾ ಲಾಗಿನ್ ಮಾಹಿತಿಯಿಲ್ಲದೆ (ಅತಿಥಿ ಬಳಕೆದಾರರಂತೆ) ವಹಿವಾಟು ನಡೆಸಲು
                  ಆಯ್ಕೆ ಮಾಡಬಹುದು. ಒಮ್ಮೆ ನೀವು KSRTC ಸೈಟ್‌ನಲ್ಲಿ ವಹಿವಾಟು ನಡೆಸಿದರೆ,
                  ಕೆಳಗೆ ಸೂಚಿಸಲಾದ ನಿಯಮಗಳು ಮತ್ತು ಷರತ್ತುಗಳಿಗೆ ನೀವು ಸಮ್ಮತಿಸಿದ್ದೀರಿ
                  ಎಂದು ಪರಿಗಣಿಸಲಾಗುತ್ತದೆ. ಈ ನಿಯಮಗಳು ಮತ್ತು ಷರತ್ತುಗಳನ್ನು ನೀವು
                  ಒಪ್ಪದಿದ್ದರೆ, ನೀವು ಈ ವೆಬ್‌ಸೈಟ್‌ನಲ್ಲಿ ವಹಿವಾಟು ನಡೆಸಲು ಸಾಧ್ಯವಿಲ್ಲ.
                  ಬುಕಿಂಗ್ ಪ್ರಕ್ರಿಯೆಯಲ್ಲಿ ನಿಯಮಗಳು ಮತ್ತು ಷರತ್ತುಗಳ ಕೆಳಭಾಗದಲ್ಲಿರುವ
                  'ನಾನು ಒಪ್ಪುತ್ತೇನೆ' ಬಟನ್ ಅನ್ನು ಒಮ್ಮೆ ನೀವು ಕ್ಲಿಕ್ ಮಾಡಿದ ನಂತರ,
                  ನೀವು ಈ ವೆಬ್‌ಸೈಟ್‌ನಲ್ಲಿ ವಹಿವಾಟುಗಳ ಉದ್ದೇಶಕ್ಕಾಗಿ KSRTC ಯೊಂದಿಗೆ
                  ಔಪಚಾರಿಕ ಒಪ್ಪಂದವನ್ನು ಮಾಡಿಕೊಂಡಿದ್ದೀರಿ.
                </li>
                <li>
                  ಈ ಒಪ್ಪಂದದ KSRTC ಯ ಕಾರ್ಯನಿರ್ವಹಣೆಯು ಭಾರತ ಸರ್ಕಾರದ
                  ಅಸ್ತಿತ್ವದಲ್ಲಿರುವ ಕಾನೂನುಗಳು ಮತ್ತು ಕಾನೂನು ಪ್ರಕ್ರಿಯೆಗಳಿಗೆ
                  ಒಳಪಟ್ಟಿರುತ್ತದೆ ಮತ್ತು ಈ ಒಪ್ಪಂದದಲ್ಲಿ ಒಳಗೊಂಡಿರುವ ಯಾವುದೂ ಕಾನೂನು
                  ಜಾರಿ ವಿನಂತಿಗಳನ್ನು ಅಥವಾ ಈ ವೆಬ್‌ಸೈಟ್‌ನ ನಿಮ್ಮ ಬಳಕೆಗೆ ಸಂಬಂಧಿಸಿದ
                  ಅವಶ್ಯಕತೆಗಳನ್ನು ಅನುಸರಿಸುವ KSRTC ಯ ಹಕ್ಕನ್ನು ಅವಹೇಳನ ಮಾಡುತ್ತಿಲ್ಲ
                  ಅಥವಾ ಒದಗಿಸಿದ ಮಾಹಿತಿ ಅಥವಾ ಅಂತಹ ಬಳಕೆಗೆ ಸಂಬಂಧಿಸಿದಂತೆ KSRTC ಯಿಂದ
                  ಸಂಗ್ರಹಿಸಲಾಗಿದೆ. KSRTC ಯ ಸಂಪೂರ್ಣ ವಿವೇಚನೆಯಿಂದ ನಿಯಂತ್ರಕರು ಅಥವಾ
                  ಪೋಲಿಸ್ ಅಥವಾ ಯಾವುದೇ ಇತರ ಮೂರನೇ ವ್ಯಕ್ತಿಗೆ ಅಥವಾ ವೆಬ್ ಸೈಟ್‌ಗೆ
                  ಸಂಬಂಧಿಸಿದ ವಿವಾದಗಳು ಅಥವಾ ದೂರುಗಳನ್ನು ಪರಿಹರಿಸಲು ನಿಮ್ಮ ವೆಬ್‌ಸೈಟ್
                  ಬಳಕೆಯ ವಿವರಗಳನ್ನು KSRTC ನೀಡಬಹುದು ಎಂದು ನೀವು ಒಪ್ಪುತ್ತೀರಿ.
                </li>
                <li>
                  ಈ ಒಪ್ಪಂದದ ಯಾವುದೇ ಭಾಗವು ಅನ್ವಯಿಸುವ ಕಾನೂನಿಗೆ ಅನುಸಾರವಾಗಿ
                  ಅಮಾನ್ಯವಾಗಿದೆ ಅಥವಾ ಜಾರಿಗೊಳಿಸಲಾಗದು ಎಂದು ನಿರ್ಧರಿಸಿದರೆ, ಇಲ್ಲಿ
                  ಸೂಚಿಸಲಾದ ವಾರಂಟಿ ಹಕ್ಕು ನಿರಾಕರಣೆಗಳು ಮತ್ತು ಹೊಣೆಗಾರಿಕೆ ಮಿತಿಗಳನ್ನು
                  ಒಳಗೊಂಡಂತೆ ಆದರೆ ಸೀಮಿತವಾಗಿರದೆ, ನಂತರ ಅಮಾನ್ಯ ಅಥವಾ ಜಾರಿಗೊಳಿಸಲಾಗದ
                  ನಿಬಂಧನೆಯನ್ನು ಮಾನ್ಯವಾದ, ಜಾರಿಗೊಳಿಸಬಹುದಾದ ನಿಬಂಧನೆಯಿಂದ
                  ರದ್ದುಗೊಳಿಸಲಾಗಿದೆ ಎಂದು ಪರಿಗಣಿಸಲಾಗುತ್ತದೆ. ಇದು ಮೂಲ ನಿಬಂಧನೆಯ
                  ಉದ್ದೇಶಕ್ಕೆ ಹೆಚ್ಚು ನಿಕಟವಾಗಿ ಹೊಂದಿಕೆಯಾಗುತ್ತದೆ ಮತ್ತು ಒಪ್ಪಂದದ ಉಳಿದ
                  ಭಾಗವು ಜಾರಿಯಲ್ಲಿ ಮುಂದುವರಿಯುತ್ತದೆ.
                </li>
                <li>
                  ಈ ಒಪ್ಪಂದವು ಈ ವೆಬ್‌ಸೈಟ್‌ಗೆ ಸಂಬಂಧಿಸಿದಂತೆ ಗ್ರಾಹಕರು ಮತ್ತು KSRTC
                  ನಡುವಿನ ಸಂಪೂರ್ಣ ಒಪ್ಪಂದವನ್ನು ರೂಪಿಸುತ್ತದೆ ಮತ್ತು ಈ ವೆಬ್‌ಸೈಟ್‌ಗೆ
                  ಸಂಬಂಧಿಸಿದಂತೆ ಗ್ರಾಹಕರು ಮತ್ತು KSRTC ನಡುವಿನ ಎಲೆಕ್ಟ್ರಾನಿಕ್, ಮೌಖಿಕ
                  ಅಥವಾ ಲಿಖಿತ ಎಲ್ಲಾ ಹಿಂದಿನ ಅಥವಾ ಸಮಕಾಲೀನ ಸಂವಹನಗಳು ಮತ್ತು
                  ಪ್ರಸ್ತಾಪಗಳನ್ನು ಇದು ರದ್ದುಗೊಳಿಸುತ್ತದೆ. ಈ ಒಪ್ಪಂದದ ಮುದ್ರಿತ ಆವೃತ್ತಿ
                  ಮತ್ತು ಎಲೆಕ್ಟ್ರಾನಿಕ್ ರೂಪದಲ್ಲಿ ನೀಡಲಾದ ಯಾವುದೇ ಸೂಚನೆಯು ನ್ಯಾಯಾಂಗ
                  ಅಥವಾ ಆಡಳಿತಾತ್ಮಕ ಪ್ರಕ್ರಿಯೆಗಳಲ್ಲಿ ಈ ಒಪ್ಪಂದದ ಆಧಾರದ ಮೇಲೆ ಅಥವಾ ಅದೇ
                  ಮಟ್ಟಿಗೆ ಮತ್ತು ಮೂಲತಃ ರಚಿಸಿದ ಮತ್ತು ನಿರ್ವಹಿಸಿದ ಇತರ ವ್ಯವಹಾರ
                  ದಾಖಲೆಗಳು ಮತ್ತು ದಾಖಲೆಗಳಂತೆಯೇ ಅದೇ ಷರತ್ತುಗಳಿಗೆ ಒಳಪಟ್ಟಿರುತ್ತದೆ.
                  ಮುದ್ರಿತ ರೂಪ.
                </li>
              </ol>
            </div>
          </div>
          <div className="heading-main">
            <h3>ಅತಿಥಿ ಬಳಕೆದಾರ ನಿಯಮಗಳು</h3>
            <div className="heading-main">
              ಬುಕಿಂಗ್ ಪ್ರಕ್ರಿಯೆ
              <div className="heading">
                <ol>
                  <li>
                    ಲಾಗಿನ್ ಇಲ್ಲದೆಯೇ ಬಳಕೆದಾರರು ಎರಡು ಸ್ಥಳಗಳ ನಡುವೆ ಸೇವೆಗಳನ್ನು
                    ಹುಡುಕಿದಾಗ ಅಸ್ತಿತ್ವದಲ್ಲಿರುವ ಸೈನ್-ಇನ್ ಮತ್ತು ಹೊಸ ಬಳಕೆದಾರರ
                    ಆಯ್ಕೆಯೊಂದಿಗೆ{" "}
                    <span className="span-class">ಅತಿಥಿ ಬಳಕೆದಾರ</span> ಆಯ್ಕೆಯು
                    ಲಭ್ಯವಿದೆ.
                  </li>
                  <li>
                    <span className="span-class">ಅತಿಥಿ ಬಳಕೆದಾರರು</span> ವಹಿವಾಟು
                    ಮಾಡುವಾಗ ಮಾನ್ಯವಾದ{" "}
                    <span className="span-class">ಇಮೇಲ್ ಐಡಿ</span> ಮತ್ತು{" "}
                    <span className="span-class">ಮೊಬೈಲ್ ಸಂಖ್ಯೆಯನ್ನು</span>{" "}
                    ಒದಗಿಸಬೇಕು.
                  </li>
                  <li>
                    ವಹಿವಾಟು ಪೂರ್ಣಗೊಂಡ ನಂತರ ಮತ್ತು ದೃಢೀಕರಿಸಿದ ನಂತರ, ಬುಕ್ಕಿಂಗ್
                    ಸಮಯದಲ್ಲಿ ಒದಗಿಸಲಾದ <span className="span-class">ಇಮೇಲ್</span>{" "}
                    ಐಡಿ ಮತ್ತು ಮೊಬೈಲ್ ಸಂಖ್ಯೆಗೆ ಇಮೇಲ್ ಮತ್ತು{" "}
                    <span className="span-class">SMS</span> ಕಳುಹಿಸಲಾಗುತ್ತದೆ.
                  </li>
                  <li>
                    ಟಿಕೆಟ್ ಮತ್ತು ಎಂಟಿಕೆಟ್‌ನಲ್ಲಿ, ಟಿಕೆಟ್‌ಗಳ ಮುದ್ರಣ ಮತ್ತು ರದ್ದತಿಗೆ
                    ಅಗತ್ಯವಿರುವ ಅತಿಥಿ ಬಳಕೆದಾರರಿಗೆ
                    <span className="span-class">ವಹಿವಾಟಿನ ಪಾಸ್‌ವರ್ಡ್ </span>
                    ಅನ್ನು ಕಳುಹಿಸಲಾಗುತ್ತದೆ.
                  </li>
                </ol>
              </div>
            </div>
          </div>
          <div className="heading-main">
            ಟಿಕೆಟ್‌ಗಳ ಮುದ್ರಣ / ರದ್ದತಿಗಾಗಿ ಮತ್ತು ಬೋರ್ಡಿಂಗ್ ಪಾಯಿಂಟ್‌ಗಳನ್ನು
            ಮಾರ್ಪಡಿಸಿ
            <div className="heading">
              <ol>
                <li>
                  <span className="span-class">ಅತಿಥಿ ಬಳಕೆದಾರ</span> ಲಾಗಿನ್
                  ಆಯ್ಕೆಯನ್ನು{" "}
                  <a href="http://www.www.ksrtc.in/" target="_blank">
                     www.www.ksrtc.in
                  </a>{" "}
                  ನ ಮೇಲಿನ ಬಲ ಮೂಲೆಯಲ್ಲಿ ಒದಗಿಸಲಾಗಿದೆ
                </li>
                <li>
                  ಇಲ್ಲಿ ಆಯ್ಕೆಗಳು, ಪ್ರಿಂಟ್ ಟಿಕೆಟ್ / ರದ್ದತಿಗಳು / ಬೋರ್ಡಿಂಗ್ ಪಾಯಿಂಟ್
                  ಅನ್ನು ಮಾರ್ಪಡಿಸಿ ಒದಗಿಸಲಾಗುತ್ತದೆ
                </li>
                <li>
                  ಅತಿಥಿ ಬಳಕೆದಾರರು ಈ ಆಯ್ಕೆಗಳಲ್ಲಿ ಒಂದನ್ನು ಆಯ್ಕೆ ಮಾಡಿಕೊಳ್ಳಬೇಕು
                  ಮತ್ತು ಕೆಳಗಿನ ಇನ್‌ಪುಟ್‌ಗಳನ್ನು ಒದಗಿಸಬೇಕು;
                  <div>
                    <span className="span-class"> PNR</span> ಸಂಖ್ಯೆ, <br />
                    <span className="span-class"> ಇಮೇಲ್ ಐಡಿ </span>(ಬುಕಿಂಗ್
                    ಮಾಡುವಾಗ ಒದಗಿಸಲಾಗಿದೆ), <br />
                    <span className="span-class"> ಮೊಬೈಲ್ ಸಂಖ್ಯೆ </span>(ಬುಕಿಂಗ್
                    ಮಾಡುವಾಗ ಒದಗಿಸಲಾಗಿದೆ) ಮತ್ತು
                    <br />
                    <span className="span-class"> ವಹಿವಾಟು ಪಾಸ್‌ವರ್ಡ್</span>
                    ಬುಕಿಂಗ್ ನಂತರ Eticket / Mticket ಮೂಲಕ ಕಳುಹಿಸಲಾಗಿದೆ.
                  </div>
                </li>
                <li>
                  ಟಿಕೆಟ್ ಬುಕ್ ಮಾಡಿದ ಸೇವೆಗಾಗಿ ಟ್ರಿಪ್‌ಶೀಟ್ ರಚಿಸುವವರೆಗೆ ಬೋರ್ಡಿಂಗ್
                  ಪಾಯಿಂಟ್ ಅನ್ನು ರದ್ದುಪಡಿಸಲು ಮತ್ತು ಮಾರ್ಪಡಿಸಲು ಅನುಮತಿಸಲಾಗಿದೆ ಮತ್ತು
                  ನಂತರ ಅನುಮತಿಸಲಾಗುವುದಿಲ್ಲ.
                </li>
              </ol>
            </div>
          </div>
          <div className="heading-main">
            ಟಿಕೆಟ್ ಬುಕ್ ಮಾಡುವ ವಿಧಾನ:
            <div className="heading">
              ಆನ್‌ಲೈನ್ ಬುಕಿಂಗ್ (ಇಂಟರ್ನೆಟ್ ಬುಕಿಂಗ್) ಪ್ರಯಾಣಿಕರಿಗೆ ಸೀಟುಗಳನ್ನು
              ಕಾಯ್ದಿರಿಸಲು ಮತ್ತು KSRTC ಕೌಂಟರ್‌ಗಳು ಅಥವಾ ಫ್ರಾಂಚೈಸಿಗಳು ಲಭ್ಯವಿಲ್ಲದ
              ದೂರದ ಸ್ಥಳಗಳಿಂದಲೂ ಇತರ ಸಂಬಂಧಿತ ವಹಿವಾಟುಗಳನ್ನು ನಡೆಸಲು ಅನುವು
              ಮಾಡಿಕೊಡುತ್ತದೆ. ಅತಿಥಿ ಬಳಕೆದಾರರಿಂದ ಬುಕಿಂಗ್ ಮಾಡುವ ವಿಧಾನ ಮತ್ತು
              ಮಾರ್ಗಸೂಚಿಗಳನ್ನು ಕೆಳಗೆ ವಿವರಿಸಲಾಗಿದೆ;
              <div className="heading">
                <ol>
                  <li>
                    ಟಿಕೆಟ್‌ಗಳನ್ನು ಬುಕ್ ಮಾಡುವಾಗ ಅತಿಥಿ ಬಳಕೆದಾರರು ಮಾನ್ಯವಾದ ಇಮೇಲ್
                    ಐಡಿ ಮತ್ತು ಮೊಬೈಲ್ ಸಂಖ್ಯೆಯನ್ನು ಒದಗಿಸಬೇಕಾಗುತ್ತದೆ. ಬಳಕೆದಾರನು
                    ತನ್ನ ಪ್ರಯಾಣದ ಅವಶ್ಯಕತೆಗಳನ್ನು ಒದಗಿಸಬೇಕು ಮತ್ತು ಆಯ್ಕೆ ಮತ್ತು
                    ಲಭ್ಯತೆಯ ಆಧಾರದ ಮೇಲೆ ಸೇವೆ, ಆಸನಗಳನ್ನು ಆರಿಸಿಕೊಳ್ಳಬೇಕು.
                  </li>
                  <li>
                    ಬುಕ್ಕಿಂಗ್ ಅನ್ನು ದೃಢೀಕರಿಸುವ ಮೊದಲು, ಪಾವತಿ ಗೇಟ್‌ವೇ ಮೂಲಕ
                    ಪಾವತಿಯನ್ನು ಸ್ವೀಕರಿಸಲು ಪ್ರಯಾಣಿಕರು 'ಪ್ರಮುಖ ಬ್ಯಾಂಕ್‌ಗಳಿಂದ
                    ಕ್ರೆಡಿಟ್ ಕಾರ್ಡ್ / ಡೆಬಿಟ್ ಕಾರ್ಡ್ / ಇಂಟರ್ನೆಟ್ ಬ್ಯಾಂಕಿಂಗ್' ನಂತಹ
                    ಪಾವತಿ ವಿವರಗಳನ್ನು ಒದಗಿಸಬೇಕಾಗುತ್ತದೆ. ಹಣಕಾಸು ಗೇಟ್‌ವೇ ವಹಿವಾಟನ್ನು
                    ಅನುಮೋದಿಸಿದ ನಂತರ ಬುಕಿಂಗ್ ಅನ್ನು ದೃಢೀಕರಿಸಲಾಗುತ್ತದೆ. ಬುಕ್ಕಿಂಗ್
                    ದೃಢೀಕರಣದ ನಂತರ ಎಟಿಕೆಟ್ / ಎಂಟಿಕೆಟ್ ಅನ್ನು ಈ ಇಮೇಲ್ ಐಡಿ ಮತ್ತು
                    ಮೊಬೈಲ್ ಸಂಖ್ಯೆಗೆ ಮಾತ್ರ ಕಳುಹಿಸಲಾಗುತ್ತದೆ.
                  </li>
                  <li>
                    ಟಿಕೆಟ್ ರದ್ದುಗೊಳಿಸುವಿಕೆ ಮತ್ತು ಟಿಕೆಟ್‌ಗಳ ಮುದ್ರಣಕ್ಕಾಗಿ,
                    ವಹಿವಾಟಿನ ಪಾಸ್‌ವರ್ಡ್ ಅನ್ನು ಸಿಸ್ಟಮ್‌ನಿಂದ ರಚಿಸಲಾಗುತ್ತದೆ ಮತ್ತು
                    ಎಂಟಿಕೆಟ್‌ನೊಂದಿಗೆ ಬಳಕೆದಾರರಿಗೆ ಕಳುಹಿಸಲಾಗುತ್ತದೆ. ಈ ವಹಿವಾಟು
                    ನಡೆಸುವವರಿಗೆ ಈ ವಹಿವಾಟಿನ ಪಾಸ್‌ವರ್ಡ್ ಕಡ್ಡಾಯವಾಗಿದೆ.
                  </li>
                  <li>
                    ಮೇಲೆ ತಿಳಿಸಿದ ವಹಿವಾಟಿನ ಸಮಯದಲ್ಲಿ, ಅತಿಥಿ ಬಳಕೆದಾರರು ಟಿಕೆಟ್‌ನ PNR
                    ಸಂಖ್ಯೆ, ಇಮೇಲ್ ಐಡಿ (ಬುಕಿಂಗ್ ಸಮಯದಲ್ಲಿ ನೀಡಲಾಗಿದೆ), ಮೊಬೈಲ್
                    ಸಂಖ್ಯೆ (ಬುಕಿಂಗ್ ಸಮಯದಲ್ಲಿ ನೀಡಲಾಗಿದೆ) ಮತ್ತು ವಹಿವಾಟಿನ
                    ಪಾಸ್‌ವರ್ಡ್ ಅನ್ನು ನೀಡಬೇಕಾಗುತ್ತದೆ.
                  </li>
                  <li>
                    ಅತಿಥಿ ಬಳಕೆದಾರರು ಕೆಎಸ್‌ಆರ್‌ಟಿಸಿ ವೆಬ್‌ಸೈಟ್‌ನಿಂದ ಟಿಕೆಟ್
                    ರದ್ದುಗೊಳಿಸಲು ಮಾನ್ಯವಾದ ಪಿಎನ್‌ಆರ್ ಸಂಖ್ಯೆ, ಇಮೇಲ್ ವಿಳಾಸ, ಮೊಬೈಲ್
                    ಸಂಖ್ಯೆ ಮತ್ತು ವಹಿವಾಟು ಪಾಸ್‌ವರ್ಡ್ ಅನ್ನು ಒದಗಿಸಬಹುದು. ರದ್ದತಿಗೆ
                    ಸಂಬಂಧಿಸಿದಂತೆ, ಮರುಪಾವತಿಗಳನ್ನು ಸಂಬಂಧಪಟ್ಟ ಕ್ರೆಡಿಟ್ ಕಾರ್ಡ್ /
                    ಡೆಬಿಟ್ ಕಾರ್ಡ್ / ಇಂಟರ್ನೆಟ್ ಬ್ಯಾಂಕಿಂಗ್ ಖಾತೆಗೆ ಮಾತ್ರ
                    ಮಾಡಲಾಗುತ್ತದೆ.
                  </li>
                  <li>
                    ಅತಿಥಿ ಬಳಕೆದಾರರು ಇಮೇಲ್ ಐಡಿ ಮತ್ತು ವಹಿವಾಟಿನ ದಿನಾಂಕವನ್ನು ಒದಗಿಸುವ
                    ಮೂಲಕ ತಮ್ಮ ವಹಿವಾಟಿನ ವಿವರಗಳನ್ನು ಹುಡುಕಬಹುದು.
                  </li>
                </ol>
              </div>
            </div>
          </div>

          <div className="heading-main">
            ಆನ್‌ಲೈನ್ / ಮೊಬೈಲ್ ಬುಕಿಂಗ್‌ಗಳಿಗಾಗಿ ಮರುಪಾವತಿಗಳು (ಖಾತೆ ವಿಭಾಗ)
            <div className="heading">
              <div className="heading">
                <span className="span-class"> ವಿಫಲ ವಹಿವಾಟುಗಳು</span>  (ಮೊತ್ತ
                ಕಡಿತಗೊಳಿಸಲಾಗಿದೆ, ಆದರೆ ಟಿಕೆಟ್ ಬುಕ್ ಮಾಡಲಾಗಿಲ್ಲ): ವಿಫಲ ವಹಿವಾಟುಗಳಿಗೆ
                ಮರುಪಾವತಿಯನ್ನು ಏಳು ಕೆಲಸದ ದಿನಗಳಲ್ಲಿ ಬಳಕೆದಾರರ ಖಾತೆಗೆ ಸ್ವಯಂಚಾಲಿತವಾಗಿ
                ಕ್ರೆಡಿಟ್ ಮಾಡಲಾಗುತ್ತದೆ. ಏಳು ದಿನಗಳಲ್ಲಿ ಮರುಪಾವತಿಯನ್ನು
                ಸ್ವೀಕರಿಸದಿದ್ದರೆ, ಈ ಕೆಳಗಿನ ವಿವರಗಳೊಂದಿಗೆ onlinerefund@ksrtc.org
                (ಖಾತೆ ವಿಭಾಗ) ಗೆ ಇಮೇಲ್ ಕಳುಹಿಸಲು ಬಳಕೆದಾರರನ್ನು ವಿನಂತಿಸಲಾಗಿದೆ.
              </div>
              <div className="heading">
                <span className="span-class"> ಅಗತ್ಯವಿರುವ ವಿವರಗಳು: </span>OB ಸಂ.
                ಅಥವಾ ಇಮೇಲ್ ಐಡಿ ಮತ್ತು ವಹಿವಾಟಿನ ದಿನಾಂಕ.
              </div>
              <div className="heading">
                ಅತಿಥಿ ಬಳಕೆದಾರರು KSRTC ಮುಖಪುಟದಲ್ಲಿ "ಅತಿಥಿ ಬಳಕೆದಾರರ ಟಿಕೆಟ್"
                ಲಿಂಕ್‌ನಿಂದ ವಹಿವಾಟಿನ ಸ್ಥಿತಿಯನ್ನು ಪರಿಶೀಲಿಸಬಹುದು.
              </div>
              <div className="heading">
                <span className="span-class"> ರದ್ದಾದ ಟಿಕೆಟ್‌ಗಳು: </span>ರದ್ದಾದ
                ಟಿಕೆಟ್‌ಗಳಿಗೆ ಮರುಪಾವತಿಯು ಏಳು ಕೆಲಸದ ದಿನಗಳಲ್ಲಿ ಬಳಕೆದಾರರ ಖಾತೆಗೆ
                ಸ್ವಯಂಚಾಲಿತವಾಗಿ ಕ್ರೆಡಿಟ್ ಆಗುತ್ತದೆ. ಏಳು ದಿನಗಳಲ್ಲಿ ಮರುಪಾವತಿಯನ್ನು
                ಸ್ವೀಕರಿಸದಿದ್ದರೆ, ಓಬಿ ಸಂಖ್ಯೆ ಅಥವಾ PNR ಸಂಖ್ಯೆಯನ್ನು ಉಲ್ಲೇಖಿಸಿ
                onlinerefund@ksrtc.org (ಖಾತೆಗಳ ವಿಭಾಗ) ಗೆ ಇಮೇಲ್ ಕಳುಹಿಸಲು
                ಬಳಕೆದಾರರನ್ನು ವಿನಂತಿಸಲಾಗಿದೆ. ರದ್ದಾದ ಟಿಕೆಟ್.
              </div>
              <div className="heading">
                <span className="span-class">
                  ಸಂಪರ್ಕ ಸಂಖ್ಯೆಗಳು:  080-22220386 and 080-22221321 Ext. 283,
                </span>
                 ಎಲ್ಲಾ ಕೆಲಸದ ದಿನಗಳಲ್ಲಿ ಕಛೇರಿ ಸಮಯದಲ್ಲಿ (ಸೋಮವಾರ-ಶುಕ್ರವಾರ 1000-1730
                ಗಂಟೆಗಳು ಮತ್ತು ಶನಿವಾರದಂದು 1000-1330 ಗಂಟೆಗಳ ನಡುವೆ).
              </div>
              <div className="heading">
                <span className="span-class"> ಪ್ರಮುಖ: </span> ಉಳಿದಿರುವ ನಿಯಮಗಳು
                ಮತ್ತು ಷರತ್ತುಗಳಿಗಾಗಿ "ಮೀಸಲಾತಿಗಳು - ನಿಯಮಗಳು ಮತ್ತು ಷರತ್ತುಗಳು" ಅನ್ನು
                ಉಲ್ಲೇಖಿಸಲು ಅತಿಥಿ ಬಳಕೆದಾರರನ್ನು ವಿನಂತಿಸಲಾಗಿದೆ.
              </div>
              <div className="heading">
                <span className="span-class">
                  ಎಲ್ಲಾ ಬಳಕೆದಾರರನ್ನು ವಿನಂತಿಸಲಾಗಿದೆ 'ತಮ್ಮ ಆನ್‌ಲೈನ್ ಬ್ಯಾಂಕಿಂಗ್ /
                  ಕ್ರೆಡಿಟ್ ಕಾರ್ಡ್ / ಡೆಬಿಟ್ ಕಾರ್ಡ್ ವಿವರಗಳನ್ನು ಯಾವುದೇ ಸಂಸ್ಥೆಯ
                  ಯಾವುದೇ ವ್ಯಕ್ತಿಗೆ ಹಂಚಿಕೊಳ್ಳಬೇಡಿ.
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GuestUsersTermsKn;
